import React from 'react';
import { useNavigate } from 'react-router-dom';
import { bookData } from '../data/mockData';
import { MessageCircle, Quote, BookOpen } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const BookSection = () => {
  const navigate = useNavigate();

  return (
    <section id="libro" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-4">
            Nuestro Primer Libro
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-amber-800 mx-auto"></div>
        </div>

        {/* Book Showcase */}
        <div className="grid md:grid-cols-2 gap-12 items-start max-w-6xl mx-auto mb-16">
          {/* Book Cover */}
          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-600 to-amber-800 rounded-lg opacity-20 group-hover:opacity-30 blur transition-opacity duration-300"></div>
            <img 
              src={bookData.coverImage}
              alt={bookData.title}
              className="relative w-full rounded-lg shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500"
            />
          </div>

          {/* Book Details */}
          <div className="space-y-6">
            <div>
              <h3 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-3 leading-tight">
                {bookData.title}
              </h3>
              <p className="text-xl text-amber-700 font-medium mb-2">{bookData.subtitle}</p>
              <p className="text-lg text-gray-600">Por {bookData.author} • {bookData.year}</p>
            </div>

            {/* Author Bio */}
            <Card className="bg-gray-50 border-none shadow-md">
              <CardContent className="p-6">
                <p className="text-gray-700 leading-relaxed">{bookData.authorBio}</p>
              </CardContent>
            </Card>

            {/* Synopsis */}
            <div>
              <h4 className="text-2xl font-serif font-bold text-gray-900 mb-3">Sobre el libro</h4>
              <p className="text-gray-700 leading-relaxed">{bookData.synopsis}</p>
            </div>

            {/* CTA Principal - Leer Preview */}
            <button
              onClick={() => navigate('/reader/register')}
              className="w-full flex items-center justify-center space-x-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-8 py-5 rounded-full text-xl font-bold transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl mb-4"
            >
              <BookOpen size={28} />
              <span>Leer las primeras 30 páginas gratis</span>
            </button>

            {/* Purchase Button */}
            <div className="pt-2">
              <a 
                href={bookData.purchaseLinks.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary w-full flex items-center justify-center space-x-3 bg-gradient-to-r from-amber-600 to-amber-800 hover:from-amber-700 hover:to-amber-900 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                <MessageCircle size={24} />
                <span>Comprar por WhatsApp</span>
              </a>
            </div>
          </div>
        </div>

        {/* Testimonial */}
        <Card className="max-w-3xl mx-auto bg-gradient-to-br from-amber-50 to-white border-amber-200 shadow-xl">
          <CardContent className="p-8 md:p-12">
            <Quote className="text-amber-600 mb-4" size={48} />
            <p className="text-2xl font-serif italic text-gray-800 mb-4 leading-relaxed">
              "{bookData.testimonial.quote}"
            </p>
            <p className="text-gray-600 text-right">— {bookData.testimonial.author}</p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};